import { render, staticRenderFns } from "./addParticipants.vue?vue&type=template&id=aa2a0652&scoped=true"
import script from "./addParticipants.vue?vue&type=script&lang=js"
export * from "./addParticipants.vue?vue&type=script&lang=js"
import style0 from "./addParticipants.vue?vue&type=style&index=0&id=aa2a0652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2a0652",
  null
  
)

export default component.exports